import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './RestaurantWithRequiredComment.module.scss';

const RestaurantWithRequiredComment: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);
	const restaurant = dishForFullInfo?.restaurantsDishes.filter((restaurant) => restaurant.isCommentRequired) || [];

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="requiredCommentLabel" theme="neutralLight" size="xs" />
			<div className={style.list}>
				{restaurant.length
					? restaurant.map((el) => {
							return (
								<div key={el.restaurantId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.restaurantName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default RestaurantWithRequiredComment;
